import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./PriceFilter.css";

const PRESET_VALUES = [50000, 100000, 200000, 300000, 500000];

/**
 * 가격 필터
 * @param priceMin
 * @param priceMax
 * @param onApply
 * @param isMobile
 * @returns {Element}
 * @constructor
 */
const PriceFilter = ({ priceMin, priceMax, onApply, isMobile = false }) => {
  const safeToString = (v) => (v === null || v === undefined ? "" : String(v));

  const [inputs, setInputs] = useState({
    min: safeToString(priceMin),
    max: safeToString(priceMax),
  });

  useEffect(() => {
    if (!isMobile) {
      setInputs({
        min: safeToString(priceMin),
        max: safeToString(priceMax),
      });
    }
  }, [priceMin, priceMax, isMobile]);

  const handleChange = (type) => (e) => {
    const { value } = e.target;

    if (isMobile) {
      const newMin = type === "min" ? value : priceMin;
      const newMax = type === "max" ? value : priceMax;
      onApply(
        newMin === "" ? null : parseInt(newMin, 10),
        newMax === "" ? null : parseInt(newMax, 10),
      );
    } else {
      setInputs((prev) => ({ ...prev, [type]: value }));
    }
  };

  const handlePreset = useCallback(
    (max) => {
      if (isMobile) {
        onApply(0, max);
      } else {
        setInputs({ min: "0", max: String(max) });
      }
    },
    [isMobile, onApply],
  );

  const handleApply = () => {
    onApply(
      inputs.min === "" ? null : parseInt(inputs.min, 10),
      inputs.max === "" ? null : parseInt(inputs.max, 10),
    );
  };

  const minInputVal = isMobile ? priceMin : inputs.min;
  const maxInputVal = isMobile ? priceMax : inputs.max;

  return (
    <div className="price-filter">
      <div className="price-range-container">
        <p className="title">최소</p>
        <input
          type="number"
          placeholder="0"
          value={safeToString(minInputVal)}
          onChange={handleChange("min")}
          min="0"
          className="price-input"
        />
        <span className="price-separator">-</span>
        <p className="title">최대</p>
        <input
          type="number"
          placeholder="0"
          value={safeToString(maxInputVal)}
          onChange={handleChange("max")}
          min="0"
          className="price-input"
        />
      </div>
      <div className="price-presets">
        {PRESET_VALUES.map((max) => (
          <button
            key={max}
            className="preset-button"
            onClick={() => handlePreset(max)}
          >
            {max / 10000}만원 이하
          </button>
        ))}
      </div>
      {!isMobile && (
        <div className="price-apply-container">
          <button className="apply-button" onClick={handleApply}>
            적용
          </button>
        </div>
      )}
    </div>
  );
};

PriceFilter.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  onApply: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default PriceFilter;
